import * as i0 from "@angular/core";
var EnvService = /** @class */ (function () {
    function EnvService() {
        // The values that are defined here are the default values that can
        // be overridden by env.js
        // API url
        this.servicePath = 'http://mybiz6-lite.mybiz.net/AppService/AppService.svc/';
        this.showAppVersion = true;
        this.loginBackdrop = "../../assets/images/business-1-dark.jpg";
        this.supplierBackdrop = '../../assets/images/business-1.jpg';
        this.portalTitle = "MyBiz eProcurement Portal";
        this.portalTab = "MyBiz Lite Dev";
        this.portalName = 'MyBiz';
        this.userGuidesHtml = "WelcometoMyBizeProcurementPortal.html";
        this.userGuidesBuyer = "";
        this.userGuidesSupplier = "";
        this.ImportNoteOnFileUpload = '';
        this.allowRegistration = "Register As Supplier";
        this.allowContactUs = "Contact Us";
        this.allowSupplierApplication = '';
        this.headersOrder = ['allowSupplierApplication', 'allowContactUs'];
        this.supplierHeaderText = '<h2>MYBIZ SUPPLIER NETWORK</h2><p>Connect. Grow.</p>';
        this.registerNote = '';
        this.logoutURL = '';
        this.pageNotFoundMessage = '';
        this.pageNotFoundHeader = '';
        this.showMyBookmarks = true;
        this.showBudgetIconToolTipText = true;
        this.primaryColor = '#007BC4';
        this.secondaryColor = '#EDF7FD';
        this.accentColor = '#4A98DC';
        this.baseColor = '#f8f8f8';
        this.iconColor = '#495057';
        this.enableCaptcha = false;
        this.sessionTimeout = 15;
        this.checkIntervalUpdate = 5;
        this.shortHeader = false;
        this.chartExpand = false;
        this.showLoginTerms = false;
        this.footerText = "Copyright © 2019 MyBiz Solutions Sdn Bhd. All rights reserved";
        this.captchaKey = "6Ld9260UAAAAAI6QMMrnC8NM7fNLSdemJoAVMlfZ";
        this.ShowDateTime = true;
        this.ShowLanguage = true;
        this.Filterreport = "RPF";
        this.ReportFromDateMonth = 3;
        this.ReportToDate = new Date();
        this.ShowReportExportCurrentView = true;
        // public captchaKey = "6Lc-ovYUAAAAAMFQkb1XcRuuBbTlvEUX4p0FlhFf";
        // Whether or not to enable debug mode
        this.enableDebug = true;
    }
    EnvService.ngInjectableDef = i0.defineInjectable({ factory: function EnvService_Factory() { return new EnvService(); }, token: EnvService, providedIn: "root" });
    return EnvService;
}());
export { EnvService };
